import _ from 'lodash';

const getters = {
  getSettings: state => {
    return state.settings;
  },
  getAppInfo: state => {
    return state.appInfo;
  },
  getPanelUpdateInfo: state => {
    return state.panelUpdateInfo;
  },
  getInstalledAddons: state => {
    return state.installedAddons;
  },
  getStateVariable: state => variableName => {
    return state[variableName];
  },
  getSites: state => {
    return state.sites;
  },
  getCurrentGroupId: state => {
    return state.currentGroupID;
  },
  getSitesByIdGroupId: state => {
    let currentGroupID = state.currentGroupID;
    if (currentGroupID == 'all') {
      return state.sites;
    }
    return _.filter(state.sites, site => {
      let groupIDs = site.groupIDs;
      if (!groupIDs) {
        return false;
      }
      return groupIDs.indexOf(currentGroupID) > -1;
    });
  },
  getGroups: state => {
    return state.groups;
  },
  getGroup: state => groupId => {
    return state.groups[groupId];
  },
  getLastReloadTime: state => {
    return state.lastReloadTime;
  },
  getPanelHistory: state => {
    return state.panelHistory;
  },
  getSitesUpdates: state => {
    return state.sitesUpdates;
  },
  getUpdates: state => hiddenItem => {
    return _.filter(state.sitesUpdates, { hiddenItem: hiddenItem });
  },
  getUpdatesForSite: state => siteId => {
    return _.filter(state.sitesUpdates, { siteID: siteId });
  },
  getReloadStats: state => siteId => {
    return state.reloadStats[siteId];
  },
  getPluginsAndThemes: state => {
    return state.pluginsAndThemes;
  },
  getPluginsAndThemesForSite: state => siteId => {
    return _.filter(state.pluginsAndThemes, { siteID: siteId });
  },
  selectedSites: (state, getters) => {
    let sites = [];
    return _.filter(getters.getSitesByIdGroupId, { selected: true });
  },
  selectedSiteIds: (state, getters) => {
    let selectedSites = getters.selectedSites;
    return _.map(selectedSites, 'siteID');
  },
  selectedSitesCount: (state, getters) => {
    return getters.selectedSites.length;
  },
  getSiteById: state => id => {
    //return state.sites.find(site => todo.id === id);
  },
  getFavorites: (state, getters) => {
    return state.favorites;
  },
  getClientPluginUpdateSites: (state, getters) => {
    return state.clientPluginUpdateSites;
  }
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js